import { RootState } from '@/store';
import { api } from '../core';
import { getCaseDocuments } from '../case';

export type DocumentBulkUploadCompleteResponse = object;

type DocumentBulkUploadCompleteProps = {
  documentIds: string[];
};

const documentBulkUploadCompleteApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postDocumentBulkUploadComplete: builder.query<DocumentBulkUploadCompleteResponse, DocumentBulkUploadCompleteProps>({
      query: ({ documentIds }: DocumentBulkUploadCompleteProps) => ({
        url: `document/bulk-upload-complete`,
        method: 'POST',
        body: {
          documentIds,
        },
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled, getState }) {
        try {
          await queryFulfilled;
          const state = getState() as RootState;

          if (
            typeof state.case.caseId === 'string' &&
            state.caseDocuments.caseDocumentsPagination.pageIndex >= 0 &&
            state.caseDocuments.caseDocumentsPagination.pageSize > 0
          ) {
            dispatch(
              getCaseDocuments.initiate(
                {
                  caseId: state.case.caseId,
                  pageIndex: state.caseDocuments.caseDocumentsPagination.pageIndex,
                  pageSize: state.caseDocuments.caseDocumentsPagination.pageSize,
                },
                {
                  forceRefetch: true,
                },
              ),
            );
          }
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postDocumentBulkUploadComplete in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useLazyPostDocumentBulkUploadCompleteQuery } = documentBulkUploadCompleteApi;
